<div class="datacardCharts">
<div *ngIf="groupedData?.length>0">
  <p-table [value]="groupedData" [styleClass]="'custom-table'" >
    <ng-template pTemplate="header">
      <tr>
        <th colspan="2" class="header-title">Power Users ( {{formattedStartDate}} - {{formattedEndDate}} )</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr>
        <td>{{ row[0]?.userName || 'N/A' }}</td>
        <td *ngIf="row[1]">{{ row[1]?.userName || 'N/A' }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
<div *ngIf="groupedData?.length === 0 && !loader" style="height: 100%;">
  <div colspan="2" class="header-title">Power Users ( {{formattedStartDate}} - {{formattedEndDate}} )</div>
    <span class="no-data-message">No Data Available</span>
</div>

</div>


